import { render } from "./Main.vue?vue&type=template&id=209f6e6c"
const script = {}
script.render = render

export default script